import { render } from "./Stat.vue?vue&type=template&id=70686cac&scoped=true"
import script from "./Stat.vue?vue&type=script&lang=js"
export * from "./Stat.vue?vue&type=script&lang=js"

import "./Stat.vue?vue&type=style&index=0&id=70686cac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70686cac"]])

export default __exports__